import { Component, inject, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { MagazineService } from '../../core/services/magazine.service';
import { ImgFadeDirective } from '../../shared/directives/img-fade.directive';
import { magazineHasReader, magazineCoverSrc } from '../../shared/utils/magazine.util';

@Component({
  standalone: true,
  imports: [RouterLink, DatePipe, ImgFadeDirective, TranslatePipe],
  templateUrl: './magazine-page.component.html',
  styleUrl: './magazine-page.component.css'
})
export class MagazinePageComponent implements OnInit {
  readonly magazineService = inject(MagazineService);
  readonly hasReader = magazineHasReader;
  readonly coverSrc = magazineCoverSrc;

  ngOnInit(): void {
    if (!this.magazineService.magazines().length) {
      this.magazineService.loadMagazines();
    }
  }
}
